/**
 * SPECIAL COPY FOR THE CONTENT PLATFORM
 *
 * NOT THE SAME AS USED WITH THE SPA
 *
 *
 * See docs
 * - https://mui.com/guides/server-rendering/
 * - https://github.com/mui-org/material-ui/tree/5daaf9be5115b1cb777fb4cf3d9125baddfe5720/examples/nextjs-with-typescript
 * - https://docs.tss-react.dev/ssr/gatsby
 */

import createCache, { EmotionCache } from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { TssCacheProvider } from 'tss-react'
import { ReactNode } from 'react'

export type { EmotionCache }

// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows overriding MUI with other styles, including CSS modules.
export function createEmotionCache(): EmotionCache {
    return createCache({ key: 'css', prepend: true })
}

// Combined provider for both Emotion and tss-react
export function EmotionCacheProvider({ cache, children }: { cache: EmotionCache; children: ReactNode }) {
    return (
        <CacheProvider value={cache}>
            <TssCacheProvider value={cache}>{children}</TssCacheProvider>
        </CacheProvider>
    )
}
